export default __webpack_public_path__ + "static/media/ishwariyam logo.3403cbe5.jpg";